'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CoreNavigation = undefined;

var _themeProvider = require('@spp/theme-provider');

var _CoreNavigation = require('./CoreNavigation');

var _CoreNavigation2 = _interopRequireDefault(_CoreNavigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/no-named-as-default */
exports.CoreNavigation = _CoreNavigation2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-core-navigation')(_CoreNavigation2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/CoreNavigation/index.js
 ** module id = 597
 ** module chunks = 1
 **/